import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { dropAICampaignRecipientEmail } from './useAICampaignRecipientEmail';
import { invalidateAICampaignRecipients } from './useAICampaignRecipients';

interface RemoveRecipientVariables {
	bulkEmailMessageId: string;
	contactId: string;
}

export const useRemoveCampaignRecipient = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation<Api.ICampaign, Api.IOperationResultNoValue, RemoveRecipientVariables>({
		mutationFn: ({ bulkEmailMessageId, contactId }) => {
			return userSession.webServiceHelper.callAsync<Api.ICampaign>(
				`Email/${encodeURIComponent(bulkEmailMessageId)}/recipients/${encodeURIComponent(contactId)}`,
				'DELETE'
			);
		},
		onError,
		onSuccess: (_data, variables) => {
			invalidateAICampaignRecipients(variables.bulkEmailMessageId);
			dropAICampaignRecipientEmail(variables.bulkEmailMessageId, variables.contactId);
			onSuccess?.();
		},
	});
};
